import type { ComponentProps } from "react";
import { addLazyParts } from "../../lib/page-readiness";
import { readyLazy } from "../../lib/ready-lazy";
import type {
  LeagueBlockView as LeagueBlockElement,
  LeagueHandbook as LeagueHandbookElement,
  LeagueSection as LeagueSectionElement,
  RichText as RichTextElement,
} from "./league-nodes";

// League guides' elements (the Handbook and its cards, game icons in text) are most of the page
// renderer, and most creators never use them, so a page loads them only when it shows one. Each
// draws inside a Suspense boundary, which keeps the server's HTML in place until the browser has
// the code; the server readies them before it renders (lib/ready-lazy.ts, lib/page-readiness.ts).
// Their props are named rather than inferred from the import, which keeps page types light.

export const RichText = readyLazy<ComponentProps<typeof RichTextElement>>(() =>
  import("./league-nodes").then((module) => ({ default: module.RichText })),
);
export const LeagueHandbook = readyLazy<ComponentProps<typeof LeagueHandbookElement>>(() =>
  import("./league-nodes").then((module) => ({ default: module.LeagueHandbook })),
);
export const LeagueSection = readyLazy<ComponentProps<typeof LeagueSectionElement>>(() =>
  import("./league-nodes").then((module) => ({ default: module.LeagueSection })),
);
export const LeagueBlockView = readyLazy<ComponentProps<typeof LeagueBlockElement>>(() =>
  import("./league-nodes").then((module) => ({ default: module.LeagueBlockView })),
);

addLazyParts((node) => {
  if (node.kind === "text") return node.rich ? RichText : undefined;
  if (node.kind === "leagueHandbook") return LeagueHandbook;
  if (node.kind === "leagueSection") return LeagueSection;
  return node.kind === "leagueBlock" ? LeagueBlockView : undefined;
});
